import React from 'react';
import {
  string, bool, number, arrayOf, shape, oneOfType
} from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { SpotlightContainer as SpotlightContainerComponent } from '@thd-olt-component-react/spotlight';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function SpotlightContainer({
  id, renderDefault, variationIds = []
}) {
  return (
    <ErrorBoundary name="spotlight-container">
      <QueryProvider key={id} cacheKey={id}>
        <SpotlightContainerComponent
          componentId={id}
          componentClass="SpotlightContainer"
          fontWeight="bold"
          renderDefault={renderDefault}
          variationIds={variationIds}
          showDescription
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

SpotlightContainer.propTypes = {
  id: string,
  renderDefault: bool,
  variationIds: arrayOf(
    shape({})
  ),
};

SpotlightContainer.defaultProps = {
  id: undefined,
  renderDefault: false,
  variationIds: []
};
